import type { EvidenceItem } from "@/types/topic";

type EvidencePanelProps = {
  items: EvidenceItem[];
};

export default function EvidencePanel({ items }: EvidencePanelProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {items.map((item, index) => (
        <div
          key={item.label}
          className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
        >
          <div className="flex items-center justify-between gap-3">
            <span className="flex items-center gap-2 text-xs font-semibold text-foreground-500">
              <span className="flex h-5 w-5 items-center justify-center rounded bg-accent-100 text-accent-700">
                <i className="ri-file-text-line" aria-hidden="true"></i>
              </span>
              材料 {String(index + 1).padStart(2, "0")}
            </span>
            <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] text-foreground-600">
              {item.label}
            </span>
          </div>
          <p className="mt-3 font-heading text-base font-bold text-foreground-950">
            {item.value}
          </p>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.note}</p>
        </div>
      ))}
    </div>
  );
}